
import { getCanvas } from "../engine/CanvasManager";
import { useDesignerStore } from "../store";

export default function LayersPanel() {
  const objects = useDesignerStore((state) => state.objects);
  const removeObject = useDesignerStore((state) => state.removeObject);
  const updateObject = useDesignerStore((state) => state.updateObject);
  const selectedObject = useDesignerStore(
    (state) => state.selectedObject
  );

  const selectLayer = (object: any) => {
    const canvas = getCanvas();

    if (!canvas) return;
    if (!object.fabricObject) return;

    canvas.setActiveObject(object.fabricObject);
    canvas.requestRenderAll();
  };

  const deleteLayer = (
    e: React.MouseEvent<HTMLButtonElement>,
    object: any
  ) => {
    e.stopPropagation();

    const canvas = getCanvas();

    if (!canvas) return;
    if (!object.fabricObject) return;

    canvas.remove(object.fabricObject);
    canvas.discardActiveObject();
    canvas.requestRenderAll();

    removeObject(object.id);
  };

  const toggleVisibility = (
    e: React.MouseEvent<HTMLButtonElement>,
    object: any
  ) => {
    e.stopPropagation();

    object.fabricObject.visible = !object.visible;

    updateObject(object.id, {
      visible: !object.visible,
    });

    getCanvas()?.requestRenderAll();
  };

  const toggleLock = (
    e: React.MouseEvent<HTMLButtonElement>,
    object: any
  ) => {
    e.stopPropagation();

    const locked = !object.locked;

    object.fabricObject.set({
      selectable: !locked,
      evented: !locked,
    });

    updateObject(object.id, {
      locked,
    });

    getCanvas()?.requestRenderAll();
  };

  return (
    <div className="rounded-xl bg-slate-800 border border-slate-700 p-4 text-white">

      <h3 className="text-xl font-bold mb-4">
        🗂 Layers
      </h3>

      {objects.length === 0 ? (

        <p className="text-sm text-slate-400">
          No objects added yet.
        </p>

      ) : (

        <div className="space-y-2">

          {objects.map((object) => {

            const selected =
              selectedObject === object.fabricObject;

            return (

              <div
                key={object.id}
                onClick={() => selectLayer(object)}
                className={`rounded-xl p-3 cursor-pointer transition border ${
                  selected
                    ? "bg-cyan-700 border-cyan-400"
                    : "bg-slate-700 hover:bg-slate-600 border-transparent"
                }`}
              >

                <div className="flex items-center justify-between">

                  <div className="font-medium">

                    {object.type === "image"
                      ? "🖼"
                      : "✍"}{" "}

                    {object.name}

                  </div>

                  <div className="flex gap-2">

                    <button
                      onClick={(e) =>
                        toggleVisibility(e, object)
                      }
                      className="hover:scale-110 transition"
                      title="Show / Hide"
                    >
                      {object.visible ? "👁" : "🚫"}
                    </button>

                    <button
                      onClick={(e) =>
                        toggleLock(e, object)
                      }
                      className="hover:scale-110 transition"
                      title="Lock"
                    >
                      {object.locked ? "🔒" : "🔓"}
                    </button>

                    <button
                      onClick={(e) =>
                        deleteLayer(e, object)
                      }
                      className="hover:scale-110 transition text-red-400"
                      title="Delete"
                    >
                      🗑
                    </button>

                  </div>

                </div>

              </div>

            );

          })}

        </div>

      )}

    </div>
  );
}